

// //toast
// import toast from '@/components/Toast';

//bind_Modal
//大区绑定
import bind_modal from '@/components/AreaBind';

// copy_Modal
import copy_modal from '@/components/CopyModal';

//invite_modal
import invite_apply from '@/components/InviteApply';

let utils = {
    // $toast: toast,
    $bind_modal : bind_modal,
    $copy_modal : copy_modal,
    $invite_apply : invite_apply,
}

export default utils;